import { createSelector } from 'reselect';
import { RootState } from 'reducers/rootReducer';

const getLocalUserSettings = (state: RootState) => state.generalReducer.localUserSettings;
const get = createSelector(getLocalUserSettings, res => res);

export const localUserSettings = { get };
